import request from '@/utils/request';

export async function getDisplayBoardStock(payload) {
    return request(`/iwms-wms/wms/wave/getDisplayBoardStock?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&wrhUuid=${payload.wrhUuid}&articleUuid=${payload.articleUuid}`, {
        method: 'POST',
        body: payload
    });
}

export async function preAllocate(payload) {
    return request(`/iwms-wms/wms/picktask/preAllocate`, {
        method: 'POST',
        body: payload
    });
}

export async function preGenerate(payload) {
    return request(`/iwms-wms/wms/picktask/preGenerate/${payload.uuid}`, {
        method: 'POST',
        body: payload.items
    });
}
